import { useMemo } from 'react';
import { useSelector, useStore } from 'react-redux';
import { selectors as mentorSelectors } from 'store/modules/mentor';
import userSelectors from 'store/modules/user/selectors';
import getCurrentManagerCapabilities from '../application/useCases/getCurrentManagerCapabilities';
import { ManagerCapabilities } from '../domain/ManagerCapabilities';
import ReduxManagerRepository from '../infrastructure/ReduxManagerRepository';

const useManager = (): ManagerCapabilities => {
  const store = useStore();
  const mentor = useSelector(mentorSelectors.getMentor);
  const managerProfile = useSelector(userSelectors.getManagerProfile);

  return useMemo(() => {
    const managerRepository = new ReduxManagerRepository(store.getState);
    const execute = getCurrentManagerCapabilities({ managerRepository });
    return execute();
  }, [store, mentor, managerProfile]);
};

export default useManager;
